export default __webpack_public_path__ + "static/media/kgk.e8f82d3f.jpeg";